export default {
    scheme: 'materia',
    author: 'defman21',
    base00: '#263238',
    base01: '#2C393F',
    base02: '#37474F',
    base03: '#707880',
    base04: '#C9CCD3',
    base05: '#CDD3DE',
    base06: '#D5DBE5',
    base07: '#FFFFFF',
    base08: '#EC5F67',
    base09: '#EA9560',
    base0A: '#FFCC00',
    base0B: '#8BD649',
    base0C: '#80CBC4',
    base0D: '#89DDFF',
    base0E: '#82AAFF',
    base0F: '#EC5F67',
};
